function DecimalValueFormat({value}) {
  return Number(Number.parseFloat(value).toFixed(2)).toString();
}

export default DecimalValueFormat
